import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {RequestState, RoundType} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IUserStore} from "data/stores/user/user.store";
import type {IPlayerPoolStore} from "data/stores/player_pool/player_pool.store";
// import type {ITeamStore} from "data/stores/team/team.store";

export interface IPoolModalController extends ViewController {
	get i18n(): ILocalizationStore;
	get isOpenModal(): boolean;
	get type(): RoundType;

	togglePoolModal: () => void;
	closePoolModal: () => void;
}

@injectable()
export class PoolModalController implements IPoolModalController {
	@observable _requestState: RequestState = RequestState.IDLE;

	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.PlayerPoolStore) private _poolStore: IPlayerPoolStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get isOpenModal() {
		return this._poolStore.isOpenPoolModal;
	}

	get type() {
		return this._poolStore.filter.type as RoundType;
	}

	togglePoolModal = () => {
		this._poolStore.togglePoolModal();
	};

	closePoolModal = () => {
		this._poolStore.closePoolModal();
	};

	dispose() {
		return;
	}

	init(param: void) {
		return;
	}
}
